export const MY_CARE_POD_OPTION = {
  key: 'myCarePods',
  value: 'myCarePods',
  label: 'My Care Pods',
}
export const ALL_OPTION = { key: 'all', value: null, label: 'All' }
export const ANY_OPTION = { key: 'any', value: null, label: 'Any' }
